import { StaffingType } from '@libs/models/shifts/shift';
import { request } from '../../request';

export async function editRecurringShift(id: string, data: EditRecurringShiftRequestData) {
  const response = request.patch<void>(`/v2/shifts/${id}`, data);
  return response;
}

export type EditRecurringShiftRequestData = {
  staffingType: StaffingType | null;
  staffNurseQualificationFilterIds: string[] | null;
  departmentNodeId: string | null;
  speciality: {
    isEmpty: boolean;
    id: string | null;
  } | null;
  subDepartment: {
    isEmpty: boolean;
    id: string | null;
  } | null;
  assignee: {
    isEmpty: boolean;
    id: string | null;
    unassignReason: string | null;
  } | null;
  locationId: string | null;
  note: string | null;
  tags: string[] | null;
};
